module.exports = __webpack_public_path__ + "img/avatar_profile.e0308f0a.png";